export interface Clock {
  now(): Date;
  nowIso(): string;
}

function pad(value: number): string {
  return String(value).padStart(2, '0');
}

/** Formats the local wall-clock time; UTC would move insight day boundaries. */
function toLocalIso(date: Date): string {
  const offsetMinutes = date.getTimezoneOffset();
  const sign = offsetMinutes <= 0 ? '+' : '-';
  const absoluteOffset = Math.abs(offsetMinutes);
  const offsetHours = Math.floor(absoluteOffset / 60);
  const offsetRemainder = absoluteOffset % 60;

  return [
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`,
    `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}.${String(date.getMilliseconds()).padStart(3, '0')}`,
  ].join('T') + `${sign}${pad(offsetHours)}:${pad(offsetRemainder)}`;
}

export const systemClock: Clock = {
  now: () => new Date(),
  nowIso: () => toLocalIso(new Date()),
};

export interface FixedClock extends Clock {
  advance(milliseconds: number): void;
}

export function fixedClock(iso: string): FixedClock {
  let timestamp = Date.parse(iso);
  if (Number.isNaN(timestamp)) {
    throw new Error(`Invalid fixed clock timestamp: ${iso}`);
  }

  return {
    now: () => new Date(timestamp),
    nowIso: () => toLocalIso(new Date(timestamp)),
    advance: (milliseconds) => {
      timestamp += milliseconds;
    },
  };
}
